import {
    RETRIEVE_HOST_REPORT,
    RETRIEVE_RENTER_REPORT,
    RETRIEVE_RESERVATION_REPORT,
    RETREIVE_DRAFT_LISTING
} from "../actions/types";
  
const initialState = { hostReport : [], reservationReport: [], draftListing: [], listingCount: 0 };

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_HOST_REPORT:
        return {
          ...state, // Preserve the states of reservationReport and renterReport
          hostReport: payload,
        };

    case RETRIEVE_RENTER_REPORT:
        return {
          ...state, // Preserve the states of reservationReport and hostReport
          renterReport: payload,
        };

    case RETRIEVE_RESERVATION_REPORT:
        return {
          ...state, // Preserve the states of hostReport and renterReport
          reservationReport: payload,
        };

    case RETREIVE_DRAFT_LISTING:
      return {
        ...state,
        draftListing: payload.rows,
        listingCount: payload.count
      };

    default:
        return state;
  }
};

export default reportReducer;